import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Navigation from '../components/Navigation';
import { toast } from 'react-toastify';

function Wallet() {
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [amount, setAmount] = useState('');
  const [upi, setUpi] = useState('');
  const [loading, setLoading] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchWallet();
  }, []);

  const fetchWallet = async () => {
    try {
      const [balRes, txnRes] = await Promise.all([
        api.get('/Wallet/balance'),
        api.get('/Wallet/transactions'),
      ]);
      setBalance(balRes.data.balance || 0);
      setTransactions(txnRes.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleWithdraw = async (e) => {
    e.preventDefault();

    if (!amount || Number(amount) < 20) {
      toast.error('Minimum withdrawal is ₹20');
      return;
    }

    setLoading(true);
    try {
      const res = await api.post('/Wallet/withdraw', {
        amount: Number(amount),
        upiOrBank: upi || null,
      });
      toast.success(res.data.message);
      setAmount('');
      setUpi('');
      setShowWithdraw(false);
      fetchWallet();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Withdrawal failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 pb-20">
      <div className="bg-teal-600 text-white p-4">
        <button onClick={() => navigate(-1)} className="text-sm mb-2">← Back</button>
        <h2 className="text-xl font-bold">Payenge Wallet</h2>
      </div>

      {/* Balance Card */}
      <div className="mx-4 mt-4 bg-white rounded-2xl p-5 shadow text-center">
        <p className="text-gray-500 text-sm">Available Balance</p>
        <p className="text-4xl font-bold text-teal-600 mt-1">₹{balance}</p>
        <button
          onClick={() => setShowWithdraw(!showWithdraw)}
          className="mt-4 bg-teal-600 text-white px-6 py-2 rounded-xl font-semibold"
        >
          {showWithdraw ? 'Cancel' : 'Withdraw'}
        </button>
      </div>

      {/* Withdraw Form */}
      {showWithdraw && (
        <form onSubmit={handleWithdraw} className="mx-4 mt-4 bg-white rounded-2xl p-4 shadow space-y-3">
          <input
            type="number"
            placeholder="Amount (Min ₹20)"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
          <input
            type="text"
            placeholder="UPI ID / Bank Account"
            value={upi}
            onChange={(e) => setUpi(e.target.value)}
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-teal-600 text-white font-bold py-3 rounded-xl disabled:opacity-50"
          >
            {loading ? 'Processing...' : 'Confirm Withdraw'}
          </button>
        </form>
      )}

      {/* Transactions */}
      <div className="mx-4 mt-6">
        <h3 className="font-semibold text-gray-700 mb-3">Transaction History</h3>

        {transactions.length === 0 ? (
          <p className="text-center text-gray-400 py-6">No transactions yet</p>
        ) : (
          <div className="space-y-2">
            {transactions.map((t) => (
              <div key={t.id} className="bg-white rounded-xl p-3 shadow flex justify-between items-center">
                <div>
                  <p className="font-semibold text-sm">{t.source}</p>
                  <p className="text-xs text-gray-400">
                    {new Date(t.createdAt).toLocaleString()}
                  </p>
                </div>
                <p className={`font-bold ${t.type === 'Credit' ? 'text-green-600' : 'text-red-500'}`}>
                  {t.type === 'Credit' ? '+' : '-'}₹{t.amount}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      <Navigation />
    </div>
  );
}

export default Wallet;